import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


import { Logo } from "@/components/atoms/logo";

interface AuthTemplateProps {
  children: React.ReactNode;
  renderLogo?: React.ReactElement;
  title?: React.ReactNode | string;
  subTitle?: React.ReactNode | string;
}

const AuthTemplate = ({
  title,
  subTitle,
  children,
}: AuthTemplateProps): JSX.Element => {
  const isMobile = useMediaQuery("(max-width: 66rem)");

  return (
    <>
      <Logo
        style={{
          maxHeight: "48px", marginLeft: "8px", display: isMobile ? "none" : "flex",
        }}
      />
      <Stack
        sx={{
          backgroundColor: (theme) => theme.palette.background.default,
          height: "100vh",
          width: "100vw",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          // backgroundImage: "url('https://the7eagles.com/wp-content/uploads/2024/05/What-is-an-Image-URL-1024x576.webp')",
          backgroundSize: "100%",
          backgroundPosition: "right",
          backgroundRepeat: "no-repeat",
          px: isMobile ? "0" : "42px",
          py: 3,

        }}
      >

        <Box sx={(theme) => ({
          maxWidth: "100%",
          width: "100%",
          height: "100%",
          maxHeight: "100%",
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          py: 5,

          [theme.breakpoints.down("sm")]: {
            maxWidth: "unset",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            px: isMobile ? "0" : "42px",
          },
        })}>
          <Box
            sx={(theme) => ({
              // backgroundColor: (theme) => theme.palette.background.paper,
              // border: (theme) => `1px solid ${theme.palette.divider}`,
              borderRadius: 1,
              width: "100%",
              maxWidth: "400px",
              [theme.breakpoints.down("sm")]: {
                maxWidth: "unset",
                width: "100%",
                height: "100%",
              },
            })}
          >
            <Stack
              paddingX={3}
              sx={{
                // alignItems: "center",
                gap: 1,
                marginBottom: 3,
              }}
            >
              {/* {renderLogo} */}
              {title ? (
                <Typography
                  textAlign="left"
                  color="primary.main"
                  sx={{
                    fontSize: "2rem", // Adjust the size of the title
                    fontWeight: "bold", // Make the title bold
                  }}
                >
                  {title}
                </Typography>
              ) : null}
              {subTitle ? (
                <Typography textAlign="left" color="text.primary">
                  {subTitle}
                </Typography>
              ) : null}
            </Stack>
            <Stack gap={1} paddingX={3} paddingY={3}>
              {children}
            </Stack>
          </Box>
        </Box>
        <Box sx={(theme) => ({
          padding: theme.spacing(0, 8),
          maxWidth: "40vw",
          width: "100%",
          height: "100%",
          maxHeight: "100%",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",

          [theme.breakpoints.down("sm")]: {
            maxWidth: "unset",
            width: "100%",
            height: "100%",
            display: "none",
          },
        })}>
          <img
            src="/login.svg"
            alt="Welcome Image"
            style={{ width: "auto", height: "675px", overflow: "hidden" }}
          />
        </Box>
      </Stack>
    </>
  );
};

export { AuthTemplate };
